import { AbstractEntityMapper } from '@pf/shared-services';
import {
    AsnHeaderCreate,
    AsnHeaderDto,
    AsnHeaderRead,
    AsnHeaderSearchParams,
} from '../../entities/asn-header.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { AsnHeaderMetadataMap } from './asn-header.mapping-profile';

@Injectable()
export class AsnHeaderMapper extends AbstractEntityMapper<
    AsnHeaderRead,
    AsnHeaderCreate,
    AsnHeaderDto,
    AsnHeaderSearchParams
> {
    constructor() {
        super(AsnHeaderDto, PlatformWmsMapper, AsnHeaderMetadataMap.symbols);
    }
}
